import { Component, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { PineLabsEnum } from 'src/app/common/enums/pinelabs.enum';
import { CurrencyService } from 'src/app/util/currency.service';
import { CROSS , PAYMENT_FAIL_GIF , PAYMENT_SUCCESS_SVG , CLOSE_ICON_GRAY } from 'src/defaultImages.js';

@Component({
  selector: 'app-payment-status-popup',
  templateUrl: './payment-status-popup.component.html',
  styleUrls: ['./payment-status-popup.component.css'],
})
export class PaymentStatusPopupComponent implements OnInit {
  @Input() pmtStatus:string;
  @Input() amount:number;
  @Input() pmtSuccessText:string;
  @Input() pmtFailText:string;
  @Input() paymentMethod:string;
  currency:string='';
 
  paymentStatusText = '';
  images = {
    CROSS: CROSS,
    STATUS:PAYMENT_SUCCESS_SVG,
    CLOSE_ICON_GRAY:CLOSE_ICON_GRAY
  };

  constructor(
    private _modalRef: NzModalRef,
    private _curr: CurrencyService,
  ) {
    this.currency = this._curr.getCurrency();
  }
  ngOnInit() {
    this.paymentStatusText = this.pmtSuccessText;
    if(this.pmtStatus===PineLabsEnum.PAYMENT_FAILED){
      this.images['STATUS'] = PAYMENT_FAIL_GIF;
      this.paymentStatusText = this.pmtFailText;
    }
  }
  cancelClicked() {
    this._modalRef.close();
  }
}
